import { render, staticRenderFns } from "./ProductRewardDetail.vue?vue&type=template&id=b56f5868&"
import script from "./ProductRewardDetail.vue?vue&type=script&lang=js&"
export * from "./ProductRewardDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports